module.exports = __webpack_public_path__ + "img/hero-1.79cd99fc.svg";